import { render, staticRenderFns } from "./EditReview.vue?vue&type=template&id=640a4112&"
import script from "./EditReview.vue?vue&type=script&lang=js&"
export * from "./EditReview.vue?vue&type=script&lang=js&"
import style0 from "./EditReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports